// extracted by mini-css-extract-plugin
export var growableInput = "_5b-0";
export var tagContainer = "_5b-2";
export var textInput = "_5b-1";